export const types = {
    ON_CHANGE_QUESTION: 'ON_CHANGE_QUESTION',
    ON_CHANGE_OPTION: 'ON_CHANGE_OPTION',
};

export const onChangeQuestion = questionId => dispatch => dispatch( {
    type: types.ON_CHANGE_QUESTION,
    questionId,
} );

export const onChangeOption = optionId => dispatch => dispatch( {
    type: types.ON_CHANGE_OPTION,
    optionId,
} );



// WEBPACK FOOTER //
// ./src/actions/question.js